module.exports = __webpack_public_path__ + "img/prioritas_bosspack.e765043c.png";